/** Avatar fill / text pairs from the Figma user-icon reference. */
export const avatarColors = [
  { background: "#B9DEFF", text: "#041E44" },
  { background: "#D3CFFC", text: "#20007A" },
  { background: "#FFD600", text: "#521400" },
  { background: "#9FED62", text: "#002500" },
  { background: "#FFB8A6", text: "#041E44" },
  { background: "#CAD3D8", text: "#041E44" },
] as const;

export const avatarNeutral = avatarColors[5];

/** Stable six-bin identity; keep normalization, hash and bin count fixed. */
export function getAvatarIdentity(value?: string | null) {
  const normalized = (value ?? "").normalize("NFC").trim().replace(/\s+/gu, " ").toLowerCase();
  const label = normalized.split("@")[0];
  const match = label.match(/[\p{L}\p{N}][\p{M}]*/u);
  if (!match) return { initial: "?", colorIndex: null };
  // Uppercase can expand (ß → SS); retain one complete grapheme.
  const initial = match[0].toUpperCase().match(/[\p{L}\p{N}][\p{M}]*/u)![0];
  let hash = 2166136261;
  for (const character of normalized) {
    hash ^= character.codePointAt(0)!;
    hash = Math.imul(hash, 16777619);
  }
  return { initial, colorIndex: (hash >>> 0) % 6 };
}

/** Exact reference sizes; larger photo placeholders retain the 48px proportion. */
export function getAvatarTypography(size: number) {
  const fontSizes: Record<number, number> = { 24: 10, 32: 12, 36: 14, 48: 16 };
  return {
    fontSize: fontSizes[size] ?? Math.round(size / 3),
    fontWeight: size < 48 ? 500 : 600,
    lineHeight: 1,
  } as const;
}
